import moment from 'moment-jalaali';

export function convertIsoToJalaali(
  date: Date | string,
  customFormat: string,
  includeTime?: boolean
) {
  moment.loadPersian({
    usePersianDigits: true,
  });
  const today = moment(date);
  const format = customFormat
    ? customFormat
    : includeTime
      ? 'HH:mm - dddd - jD / jM / jYYYY'
      : 'dddd - jD / jM / jYYYY';
  const converted = today.format(format);
  return converted;
}
